import styled from 'styled-components'
import LinkedInIcon from '../icons/contact/LinkedIn'
import Image from '../Image'
import Stack, { StackItem } from '../layout/Stack'

export default function Person( { person } ) {
  const img = person.profileImage[ 0 ]

  return (
    <StyledPerson>
      <Stack $between={ 1 }>
        <StackItem $bottom={ 4 }>
          <StyledPersonImage>
            <Image 
              src={ img.url }
              alt={ person.title }
              dateModified={ img.dateModified }
              layout="fill"
              objectFit="cover"
            />
          </StyledPersonImage>
        </StackItem>
        <h2>{ person.title }</h2>
        <StackItem $bottom={ 2 }>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={ { __html: person.bodyText } }
          />
        </StackItem>
        <StyledContactLinks>
          { person.contactLinks.map( contactLink => (
            <a 
              key={ contactLink.id }
              href={ contactLink.linkUrl }
              target="_blank" 
              rel="noreferrer"
            >
              <ContactLinkIcon iconType={ contactLink.icon } />
            </a>
          ) ) }
        </StyledContactLinks>
      </Stack>
    </StyledPerson>
  )
}

function ContactLinkIcon( { iconType } ) {
  switch ( iconType ) {
    case 'linkedin': return <LinkedInIcon />
    default: return null
  }
}

const StyledPerson = styled.div`
  display: flex;
  flex-direction: column;

  p {
    &:first-child {
      margin-top: 0;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const StyledPersonImage = styled.div`
  position: relative;
  aspect-ratio: 258 / 280;
`

const StyledContactLinks = styled.div`
  a {
    display: block;
    height: 24px;

    svg {
      height: 100%;
    }
  }
`
